// extracted by mini-css-extract-plugin
module.exports = {"materials":"Materials_materials__17H9x","tip":"Materials_tip__1U1E1"};